import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../service/AppService.class';

@Component({
  selector: 'FormDetail',
  templateUrl: './formdetail.component.html',
  styleUrls: ['./formdetail.component.css']
})
export class FormdetailComponent<T> implements OnInit {
  @Input() dataservice: AppService<T>;
  close_status: boolean;
  open_status:boolean;
  tag_label : string;

  @Input() leaddata: boolean;
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Output() isduplicate: EventEmitter<number> = new EventEmitter();
  @Input() bycallerid:boolean
  @Input() byGroupid:boolean
  uType: any

  constructor(protected router: Router) {
    this.uType = parseInt(sessionStorage.getItem("type"))
  }

  ngOnInit() {

    this.dataservice.status.subscribe(res=>{
      this.dataservice.debug_log("Add button clicked");
      this.close_status=res;
      this.close.emit(res);
      if(res) {
        this.close_status = true
        this.open_status=false
      } else {
        this.close_status = false
        this.open_status=true
      }
    });

    this.dataservice.changelabel("List Details");
    this.dataservice.label.subscribe(res=>
    {
        this.tag_label=res;
    });
  }

  onClose()
  {
    this.dataservice.changelabel("List Details");
    this.dataservice.changefrm(false);
    this.dataservice.Data=null;
  }

  onAddNew()
  {
    this.dataservice.changelabel("Add New");
    this.dataservice.changefrm(true);
    this.dataservice.Data=null;
  }

  ngOnDestory()
  {
    this.dataservice.frm_label.unsubscribe();
    this.dataservice.frm_status.unsubscribe();
  }

  DulicateLeads(type:number)
  {
    this.isduplicate.emit(type);
  }

  buyDidCretid()
  {
    this.router.navigate(['/account'], {
      queryParams: {
        index: 1
      }
    });
  }

  gotoAgentGroup(){
    this.router.navigate(['/agent-groups'])
  }
}
